import type { ThemeOptions } from "@mui/material";

export const SpeedyGlassThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      lightest: "hsl(352, 100%, 85%)",
      lighter: "hsl(352, 100%, 75%)",
      light: "hsl(352, 100%, 65%)",
      main: "hsl(352, 100%, 42%)",
      dark: "hsl(352, 100%, 35%)",
      darker: "hsl(352, 100%, 25%)",
      darkest: "hsl(352, 100%, 15%)",
    },
    secondary: {
      main: "hsl(0, 100%, 0%)",
    },
    background: {
      default: "hsl(210, 25.00%, 92.20%)",
      paper: "hsl(0, 0.00%, 98.00%)",
    },
  },
};
